import { Component, OnDestroy, OnInit, TemplateRef, NgZone, ChangeDetectorRef } from '@angular/core';
import { CategoryService } from 'src/app/deebr/service/category.service';
import { Location } from '@angular/common';
import { debounceTime, Observable, Subject, firstValueFrom, EMPTY, from, of, forkJoin } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { EmailStore, Email } from './email.store';
import { DownloadService } from 'src/app/deebr/service/download.service';
import { UserService } from 'src/app/deebr/service/user.service';
import { GeneratorService } from 'src/app/deebr/service/generator.service';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { catchError, filter, take, takeUntil, tap, mergeMap, finalize, timeout } from 'rxjs/operators';
import { User } from 'src/app/deebr/store/user.store';
import { EmailPreviewPopupComponent } from 'src/app/deebr/component/pages/generator/email-preview-popup/email-preview-popup.component';
import { ViewChild } from '@angular/core';
import $ from 'jquery';
import { ToastService } from 'src/app/deebr/service/toast.service';
import { NbDialogService, NbDialogRef } from '@nebular/theme';
import { WriteOnImageComponent } from 'src/app/deebr/component/write-on-image/write-on-image.component';
import { ImageSelectionService } from '../../../service/image-selection.service';
import { LoggingService } from 'src/app/deebr/service/logging.service';
import { ImageToGifDialogComponent } from './image-to-gif-dialog/image-to-gif-dialog.component';
import { EntrepriseService } from 'src/app/deebr/service/entreprise.service';
import { ResizeImageModalComponent } from './resize-image-modal/resize-image-modal.component';
import { CategorySelectionModalComponent } from './category-selection-modal/category-selection-modal.component';
import JSZip from 'jszip';
import { FireflyChoiceComponent } from 'src/app/deebr/component/firefly-choice/firefly-choice.component';
import { ExtensionBuilder, ModificationDescription } from '@stripoinc/ui-editor-extensions';
import {
  CustomToolbarButtonControl, TextTransformControl, WriteOnImageControl,
  DynamicControl, DynamicSettingsControl, BackupControl, createSettingsRegistryClass, CopyPasteControl, GlobalExtensionState,
  purgeStripoPortableClipboard
} from './stripo-extensions';
import { DynamicImageManagementComponent } from './dynamic-image-management/dynamic-image-management.component';
import { BackupSelectionModalComponent } from './backup-selection-modal/backup-selection-modal.component';
import { environment } from 'src/environments/environment';




/**
 * Au-delà de ce délai, on ouvre l'éditeur sans la liste des catégories plutôt
 * que de laisser l'utilisateur devant un écran de chargement infini.
 */
const CATEGORIES_LOAD_TIMEOUT_MS = 15000;

/**
 * Délai au-delà duquel on considère que Stripo ne rappellera pas le callback de
 * `getTemplateData`. Généreux : sur un gros template la sérialisation prend
 * plusieurs secondes.
 */
const TEMPLATE_READ_TIMEOUT_MS = 20000;

/**
 * Âge maximal du jeton Stripo obtenu au chargement pour qu'il soit remis tel
 * quel à l'éditeur. Au-delà (import d'images très long), on en redemande un.
 */
const PREFETCHED_TOKEN_MAX_AGE_MS = 60000;

/** Délai au-delà duquel on considère que le store ne rendra pas de verdict. */
const SAVE_RESULT_TIMEOUT_MS = 60000;

/**
 * Active la fonctionnalité Backup : le contrôle `BackupControl` ET sa
 * déclaration dans le panneau de réglages. Les deux doivent rester alignés —
 * déclarer le contrôle sans le fournir met Stripo en échec de résolution.
 */
const ENABLE_BACKUP_CONTROL: boolean = false;

interface ImageData {
  url_with_text: string;
  text_only: string;
}

interface ImageResponse {
  statut: string;
  [key: string]: ImageData | string | undefined;
}

@Component({
  templateUrl: './generator-edit-v2.component.html',
  styleUrls: ['./generator-edit-v2.component.scss'],
  standalone: false
})

export class GeneratorEditV2Component implements OnInit, OnDestroy {
  @ViewChild(EmailPreviewPopupComponent) emailPreviewPopupComponent!: EmailPreviewPopupComponent;
  private destroy$: Subject<void> = new Subject();
  public userId!: number;
  public userName!: string;
  public userEmail!: string;
  public batEmails!: string;
  public lastName !: string;
  public form!: FormGroup;
  public imageForm!: FormGroup;
  public isExporting = false;
  public isSaving = false;
  public showPopup = false;
  private authToken: string | null = null;
  /**
   * Jeton obtenu pendant le chargement, remis tel quel à Stripo lors de sa
   * première demande pour lui éviter un aller-retour backend → Stripo de plus.
   * Consommé une seule fois : les demandes suivantes vont toujours au backend.
   */
  private prefetchedStripoToken: { token: string, fetchedAt: number } | null = null;
  public isLoading = true;
  previewHtmlUrl?: string;
  previewImgUrl?: string;
  emailName: string = '';
  folder_id?: number | null = null;
  private saveTimeout: any;
  loading: boolean = false;
  dialogRef: NbDialogRef<any> | undefined = undefined;
  private lastSaveTime: number = Date.now();
  @ViewChild('dialogErrorExport') dialogErrorExport!: TemplateRef<any>;
  @ViewChild('dialogErrorAnimate') dialogErrorAnimate!: TemplateRef<any>;
  @ViewChild('dialogErrorWriteOnImage') dialogErrorWriteOnImage!: TemplateRef<any>;
  @ViewChild('dialogExportTracking') dialogExportTracking!: TemplateRef<any>;
  @ViewChild('dialogErrorTracking') dialogErrorTracking!: TemplateRef<any>;
  @ViewChild('dialogPushEmail') dialogPushEmail!: TemplateRef<any>;
  @ViewChild('dialogErrorPushEmail') dialogErrorPushEmail!: TemplateRef<any>;
  @ViewChild('dialogDynamicChoice') dialogDynamicChoice!: TemplateRef<any>;
  @ViewChild('dialogDynamicConfirm') dialogDynamicConfirm!: TemplateRef<any>;
  @ViewChild('dialogDynamicConflict') dialogDynamicConflict!: TemplateRef<any>;
  conflictEmailName: string = '';
  conflictForceCallback: (() => void) | null = null;
  pendingDynamicAutomation: boolean = false;
  hasDynamicBlock: boolean = false;
  hasExistingDynamicCopy: boolean = false;
  errorMessage: string | null = null;
  email?: Email;
  initialEmailId!: number;
  public isManualSave: boolean = false;
  private isAutoSaving: boolean = false;
  /** Évite de répéter l'alerte à chaque autosave tant que le backend est KO. */
  private autosaveFailureNotified: boolean = false;
  private isDestroyed: boolean = false;
  enterpriseTracking!: string;
  enterpriseId!: number;
  enterprisePushEmail: boolean = false;
  dynamicHtml: boolean = false;
  hasSizeData: boolean = false;
  hasSizeStock: boolean = false;
  public canEditTracking: boolean = false;
  wantsTracking: boolean = false;
  public selectedImageUrl: string = '';
  public imgHeight: number = 0;
  public imgWidth: number = 0;
  public showToolbox: boolean = true;
  public loadingPreview = false;
  public loadingBat = false;
  areHiddenElementsHidden = true;
  isRestoringViewOptions = false;
  overrideToggleValue: boolean | null = null;
  selectedView: 'desktop' | 'mobile' = 'desktop';
  // Pour la méthode "destroy/recreate"
  public isToggleVisible: boolean = true;
  private canTriggerAutosave: boolean = false;
  private readonly VIEW_OPTION_KEY = 'deebr_showHiddenElements';






  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private readonly emailStore: EmailStore,
    private readonly downloadService: DownloadService,
    private readonly formBuilder: FormBuilder,
    private userService: UserService,
    private generatorService: GeneratorService,
    private toastService: ToastService,
    private dialogService: NbDialogService,
    private imageSelectionService: ImageSelectionService,
    private loggingService: LoggingService,
    private entrepriseService: EntrepriseService,
    private location: Location,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private readonly zone: NgZone,
    private categoryService: CategoryService,
  ) { }

  ngOnInit(): void {
    const saved = localStorage.getItem(this.VIEW_OPTION_KEY);
    this.areHiddenElementsHidden = saved ? saved === 'true' : true;

    // Écouter les conflits de personnalisation
    this.emailStore.dynamicConflict$.pipe(takeUntil(this.destroy$)).subscribe(({ emailName, onForce }) => {
      this.conflictEmailName = emailName;
      this.conflictForceCallback = onForce;
      this.dialogService.open(this.dialogDynamicConflict);
    });

    this.initForm();

    this.imageForm = new FormGroup({
      url: new FormControl(''),
      width: new FormControl(''),
      height: new FormControl('')
    });

    this.initialEmailId = this.route.snapshot.params['id'];

    // 💡 Étape 1 : on charge l'utilisateur
    const user$ = this.userService.getUsers().pipe(
      takeUntil(this.destroy$),
      tap((users: User[]) => {
        if (users.length === 0) {
          throw new Error('Aucun utilisateur trouvé');
        }
        this.userId = users[0].id;
        this.userEmail = users[0].email
        this.batEmails = this.userEmail;
        this.userName = users[0].first_name;
        this.lastName = users[0].last_name;
      })
    );

    // 💡 Étape 1.5 : on charge l'entreprise
    const enterprise$ = this.entrepriseService.getEntreprise().pipe(
      take(1),
      catchError((err) => {
        console.warn('Erreur chargement entreprise', err);
        return of({ count: 0, results: [] } as any);
      })
    );

    // 💡 Étape 2 : l'email
    const email$ = this.emailStore.selectEmail(this.initialEmailId).pipe(
      takeUntil(this.destroy$),
      filter(email => !!email),
      take(1)
    );

    // 💡 Étape 3 : le jeton Stripo (import des images, puis remis à l'éditeur)
    const stripoToken$ = this.getAuthToken();

    // Les catégories ne sont attendues qu'au moment d'initialiser Stripo : on
    // lance la requête dès maintenant pour qu'elle tourne en parallèle. Le
    // service partage la requête en cours, l'appel suivant n'en relance pas.
    this.categoryService.getCategories().pipe(
      take(1),
      catchError(() => EMPTY),
      takeUntil(this.destroy$),
    ).subscribe();

    // Aucune de ces requêtes ne dépend des autres : les enchaîner additionnait
    // leurs durées avant même de commencer à charger Stripo.
    forkJoin({ enterprise: enterprise$, email: email$, token: stripoToken$, users: user$ })
      .pipe(
        tap(({ enterprise, token }) => {
          if (enterprise.count > 0) {
            const e = enterprise.results[0];
            this.enterpriseTracking = e.tracking;
            this.enterpriseId = e.id;
            this.enterprisePushEmail = e.push_email;
            this.dynamicHtml = e.dynamic_html;
            this.hasSizeData = !!e.has_size_data;
            this.hasSizeStock = !!e.has_size_stock;
          }
          this.authToken = token.token;
          this.prefetchedStripoToken = { token: token.token, fetchedAt: Date.now() };
        }),
        mergeMap(({ email }) => {
          return from(this.initEditor(email!)).pipe(
            tap(() => this.setPreviewFields(email!)),
          );
        }),
        catchError(err => {
          console.error('Editor init error:', err);
          this.router.navigate(['/pages/generator']);
          return EMPTY;
        }),
        finalize(() => this.isLoading = false)
      )
      .subscribe();


    // Autres init indépendants
    this.setupAutosave();
  }

  goToV1() {
    const id = this.route.snapshot.paramMap.get('id');
    localStorage.setItem('preferred_generator_version', 'v1');
    this.router.navigate(['/pages/generator', id]);
  }

  private autosaveSubject = new Subject<void>();

  private setupAutosave(): void {
    this.autosaveSubject.pipe(
      debounceTime(500), // 10s après la dernière modif
    ).subscribe(() => {
      this.save(false); // sauvegarde "auto"
    });
  }



  private setPreviewFields(email: Email) {
    this.previewHtmlUrl = email.preview_html_url;
    this.previewImgUrl = email.preview_img_url;
    this.emailName = email.name;
    this.emailName = email.name;
    this.folder_id = email.folder_id;
    this.email = email;
  }

  openDynamicManagement() {
    if (!this.email?.campaign_id) {
      this.toastService.success("Non disponible", "Cet email n'est pas une campagne dynamique.");
      return;
    }
    this.dialogService.open(DynamicImageManagementComponent, {
      context: { emailId: this.initialEmailId }
    });
  }

  async openDynamicChoiceDialog(): Promise<void> {
    try {
      const { html } = await this.getTemplateFromEditor();
      if (!html.includes('deebr-data-dynamic="true"')) {
        this.toastService.error(
          'Dynamisation impossible',
          'Aucun bloc dynamique n\'est activ\u00e9 dans cet email. Activez la personnalisation sur au moins un bloc avant de lancer la dynamisation.'
        );
        return;
      }
      // TODO: R\u00e9tablir le choix automation/one_shot quand automation sera pr\u00eat
      // this.dialogService.open(this.dialogDynamicChoice);
      this.onDynamicTypeSelected(null, false); // one_shot directement
    } catch (err) {
      console.error('Erreur lors de la v\u00e9rification du template :', err);
      this.toastService.error('Erreur', 'Impossible de v\u00e9rifier le contenu de l\'email.');
    }
  }

  checkHasDynamicBlock(): void {
    this.getTemplateFromEditor().then(({ html }) => {
      this.zone.run(() => {
        this.hasDynamicBlock = html.includes('deebr-data-dynamic="true"');
      });
    }).catch(() => {
      // Silently ignore if editor not ready yet
    });
  }

  onDynamicTypeSelected(ref: any, automation: boolean): void {
    if (ref) ref.close();
    this.pendingDynamicAutomation = automation;

    // Vérifier si une copie personnalisée existe déjà pour cet email
    if (this.email?.id) {
      this.generatorService.checkExistingDynamicCopy(this.email.id).subscribe({
        next: (res: any) => {
          this.hasExistingDynamicCopy = res.exists || false;
          this.dialogService.open(this.dialogDynamicConfirm);
        },
        error: () => {
          this.hasExistingDynamicCopy = false;
          this.dialogService.open(this.dialogDynamicConfirm);
        }
      });
    } else {
      this.dialogService.open(this.dialogDynamicConfirm);
    }
  }

  confirmDynamic(ref: any): void {
    ref.close();
    if (!this.email) return;

    this.emailStore.createDynamicEmail({
      id: this.email.id,
      name: this.email.name + ' (dynamic)',
      useCategory: this.pendingDynamicAutomation
    });

    this.toastService.success(
      'Dynamisation lancée',
      'La création de l\'email dynamique est en cours. Vous serez averti par mail lorsque la tâche sera effectuée.'
    );
  }

  forcePersonalization(ref: any): void {
    ref.close();
    if (this.conflictForceCallback) {
      this.conflictForceCallback();
      this.toastService.success(
        'Dynamisation relancée',
        'L\'ancienne personnalisation a été arrêtée. Une nouvelle est en cours.'
      );
    }
  }

  ngOnDestroy(): void {
    // Marqué avant l'ultime sauvegarde : `removeEditor()` juste en dessous
    // empêche Stripo de répondre, donc ce save échoue presque toujours. C'est
    // sans conséquence (l'autosave a déjà écrit), mais il ne doit pas remonter
    // une alerte à l'utilisatrice qui a simplement quitté l'éditeur.
    this.isDestroyed = true;
    this.save(false);
    try {
      if ((window as any).UIEditor?.removeEditor) {
        (window as any).UIEditor.removeEditor();
      } else {
        console.warn('UIEditor.removeEditor() non disponible.');
      }
    } catch (e) {
      console.error('[ngOnDestroy] Erreur dans removeEditor:', e);
    }

    this.destroy$.next();
    this.destroy$.complete();
  }

  onBackOrCloseHistory() {
    if (this.showToolbox) {

      const previous = localStorage.getItem('editor_previous_url');
      if (previous) {
        this.router.navigateByUrl(previous);
        return;
      }

      // fallback sécurisé
      this.router.navigate(['/pages/generator']);

    } else {
      window.StripoEditorApi?.versionHistoryApi?.closeVersionHistory();
    }
  }

  openHistory() {
    window.StripoEditorApi.versionHistoryApi.openVersionHistory(
      () => { },
      () => { }
    );
  }

  sendBat() {
    const actionsApi = (window as any).StripoEditorApi?.actionsApi;

    if (!actionsApi) {
      console.error("Stripo non initialisé");
      return;
    }

    this.loadingBat = true;

    const utmParameters = window.StripoEditorApi.emailMetadataApi.getUTMParams
      ? window.StripoEditorApi.emailMetadataApi.getUTMParams()
      : {};

    actionsApi.compileEmail({
      minimize: true,
      utmEntity: utmParameters,
      mergeTags: [],
      forseAmp: false,
      resetDataSavedFlag: false,
      disableLineHeightsReplace: true,
      callback: (error: string, compiledHtml: string, ampHtml: string, ampErrors: string[]) => {

        this.loadingBat = false;

        if (error) {
          console.error("Erreur de compilation :", error);
          return;
        }

        const styledHtml = compiledHtml;
        const htmlBase64 = btoa(unescape(encodeURIComponent(styledHtml)));

        // Transforme la string en tableau d'emails
        const toList = this.batEmails
          .split(",")
          .map(e => e.trim())
          .filter(e => e.length > 0);
        const objet = "Test - " + window.StripoEditorApi.emailMetadataApi.getTitle()
        this.generatorService.sendBat(
          objet,
          htmlBase64,   // <-- envoyer le base64, pas le HTML brut
          toList
        ).subscribe({
          next: (res) => {
            console.log("BAT envoyé :", res);
            this.toastService.success("Email test envoyé !", "");
          },
          error: (err) => {
            console.error("Erreur :", err);
            this.toastService.error("Erreur lors de l'envoi du BAT", err);
          }
        });
      }
    });
  }

  copyToClipboard(text: string): void {
    if (!text) {
      console.error('Aucun texte à copier');
      return;
    }

    navigator.clipboard.writeText(text).then(() => {
      this.toastService.success('Email Creator', "Lien copié dans le presse-papiers");;
    }).catch(err => {
      console.error('Erreur lors de la copie :', err);
    });
  }

  selectView(view: 'desktop' | 'mobile') {
    this.selectedView = view;
  }

  onSelectView(view: 'desktop' | 'mobile') {
    if (this.showToolbox) {
      // Mode édition : comportement Angular normal
      this.selectView(view);
    } else {
      // Mode versionHistory (historique Stripo)
      if (window.StripoEditorApi && window.StripoEditorApi.versionHistoryApi) {
        if (view === 'desktop') {
          window.StripoEditorApi.versionHistoryApi.switchToDesktopPreview();
        } else if (view === 'mobile') {
          window.StripoEditorApi.versionHistoryApi.switchToMobilePreview();
        }
      }
      this.selectedView = view;
    }
  }

  onManualToggle(isChecked: boolean) {

    this.areHiddenElementsHidden = isChecked;
    localStorage.setItem(this.VIEW_OPTION_KEY, String(isChecked));
    this.toggleElementHiding(isChecked);
  }

  toggleElementHiding(isChecked: boolean) {

    if (this.isRestoringViewOptions) {
      return;
    }

    window.StripoEditorApi.viewOptionsApi.setViewOptions({
      showHiddenElements: isChecked
    });
  }

  /**
   * Attend le verdict du store pour la sauvegarde en cours.
   *
   * `saveEmailResult$` est un Subject partagé alimenté par un effect en
   * `switchMap` : une sauvegarde annulée par la suivante n'émet jamais rien.
   * L'attente est donc bornée, et coupée à la destruction du composant — sinon
   * `save()` ne relâcherait jamais ses verrous.
   */
  private waitForSaveResult(): Promise<'success' | 'error'> {
    return firstValueFrom(
      this.emailStore.saveEmailResult$.pipe(
        takeUntil(this.destroy$),
        timeout(SAVE_RESULT_TIMEOUT_MS),
      ),
    );
  }

  public async save(manual: boolean = false, exporting: boolean = false, folder_id: number | null = null): Promise<void> {
    // Garde de réentrance : un autosave ne double jamais un autosave en cours.
    if (this.isAutoSaving && !manual) return;

    this.isAutoSaving = !manual;
    // Le spinner du bouton « Enregistrer » ne concerne que les sauvegardes
    // manuelles. Le poser aussi sur les autosaves le faisait clignoter à chaque
    // pause de frappe, ce qui rendait un blocage définitif indiscernable du
    // fonctionnement normal.
    if (manual) {
      this.isManualSave = true;
    }

    try {
      if (!this.isExporting && manual) {
        this.isSaving = true;
      }

      const { html, css } = await this.getTemplateFromEditor();

      // Trigger Stripo Version History save
      try {
        (window as any).StripoEditorApi?.actionsApi?.save?.(() => { });
      } catch (e) { console.warn('Stripo save ignored', e); }

      const folder_id_to_use = this.folder_id;
      const previewHtmlUrl = this.previewHtmlUrl;
      const previewImgUrl = this.previewImgUrl;

      this.loggingService.log(`Saving email with ID: ${this.initialEmailId}`);
      this.emailStore.saveEmail({
        id: this.initialEmailId,
        html,
        css,
        name: this.emailName,
        preview_html_url: previewHtmlUrl,
        preview_img_url: previewImgUrl,
        isManualSave: manual,
        isExporting: exporting,
        folder_id: folder_id_to_use!
      });
      const result = await this.waitForSaveResult();
      if (result === 'error') {
        // Le store a bien répondu, mais l'API a refusé : ne surtout pas
        // afficher « sauvegardé avec succès » par-dessus.
        throw new Error("La sauvegarde de l'email a échoué côté serveur");
      }

      this.lastSaveTime = Date.now();
      this.autosaveFailureNotified = false;

      if (manual && !exporting) {
        this.toastService.success('Email Creator', 'Email sauvegardé avec succès');
      }

    } catch (error) {
      console.error('Erreur lors de la sauvegarde :', error);
      if (manual && !exporting) {
        this.toastService.error('Email Creator', 'Erreur lors de la sauvegarde');
      } else if (!manual && !this.autosaveFailureNotified && !this.isDestroyed) {
        // Un autosave qui échoue en silence, c'est du travail perdu sans que
        // l'utilisatrice s'en aperçoive. On prévient une fois par série
        // d'échecs, pour ne pas spammer si le backend est durablement KO.
        // (`manual && exporting` est exclu : l'export a sa propre gestion d'erreur.)
        this.autosaveFailureNotified = true;
        this.toastService.error(
          'Email Creator',
          "La sauvegarde automatique a échoué. Utilisez le bouton Enregistrer pour réessayer.",
        );
      }
    } finally {
      // Verrous relâchés quoi qu'il arrive. Chaque `await` de ce bloc est borné
      // dans le temps, donc ce `finally` est toujours atteint : c'est ce qui
      // garantit que l'autosave ne peut plus s'arrêter définitivement.
      if (manual) {
        this.isSaving = false;
        this.isManualSave = false;
      }
      this.isAutoSaving = false;
    }
  }

  onEmailNameChange(newName: string): void {
    this.emailName = newName;

    if (this.saveTimeout) {
      clearTimeout(this.saveTimeout);
    }

    this.saveTimeout = setTimeout(() => {
      this.save(false); // Appelez la méthode save avec false
    }, 1000);
  }

  toggleEditTracking(): void {
    this.canEditTracking = !this.canEditTracking;
    if (!this.canEditTracking) {
      this.enterpriseTracking = this.enterpriseTracking.replace(/ /g, "");
      this.enterpriseTracking = this.enterpriseTracking.replace("?", "");
      // Sauvegarder le tracking modifié via l'API
      this.saveTracking(this.enterpriseTracking);
      this.dialogRef?.close();
      this.dialogRef = undefined; // Réinitialise dialogRef
      this.openExportTrackingDialog();
    }
  }

  saveTracking(tracking: string): void {
    if (tracking.startsWith("?")) {
      tracking = tracking.substring(1);
    }
    tracking = tracking.replace(/ /g, "");
    this.generatorService.changeValueInEnterprise(this.enterpriseId, "tracking", tracking).subscribe(
      response => {

      },
      error => {
        console.error('Erreur lors de la mise à jour du tracking :', error);
      }
    );
  }

  public async export(): Promise<void> {
    try {
      this.isExporting = true;
      this.loggingService.log(`Exporting email with ID: ${this.initialEmailId}`);
      await this.save(true, true); // Sauvegarde avant export

      const utmParameters = window.StripoEditorApi.emailMetadataApi.getUTMParams
        ? window.StripoEditorApi.emailMetadataApi.getUTMParams()
        : {};


      const compileEmailPromise = () =>
        new Promise<{ html: string, ampHtml?: string, ampErrors?: string[] }>((resolve, reject) => {
          window.StripoEditorApi.actionsApi.compileEmail({
            minimize: true,
            utmEntity: utmParameters,  // <= Les UTM sont injectés ici
            mergeTags: [], // optionnel, adapte si tu utilises des merge tags
            forseAmp: false,
            resetDataSavedFlag: false,
            disableLineHeightsReplace: true,
            callback: (error: any, html: string, ampHtml: string, ampErrors: string[]) => {
              if (error) {
                reject(error);
              } else {
                resolve({ html, ampHtml, ampErrors });
              }
            }
          });
        });

      const { html: exportedHtml, ampHtml: exportedAmpHtml } = await compileEmailPromise();

      // -- Export, Push, ou Download comme avant :
      if (this.enterprisePushEmail === false) {
        if (exportedAmpHtml) {
          // Crée un ZIP HTML+AMP
          const zip = new JSZip();
          zip.file(`${window.StripoEditorApi.emailMetadataApi.getTitle()}-HTML.html`, exportedHtml);
          zip.file(`${window.StripoEditorApi.emailMetadataApi.getTitle()}-AMP.html`, exportedAmpHtml);
          const content = await zip.generateAsync({ type: 'blob' });
          this.downloadService.saveAs(content, `${window.StripoEditorApi.emailMetadataApi.getTitle()}.zip`);
        } else {
          // Juste HTML classique
          this.downloadService.saveAs(exportedHtml, `${window.StripoEditorApi.emailMetadataApi.getTitle()}.html`);
        }
        this.isExporting = false;
      } else if (this.enterprisePushEmail === true) {
        // Push dans l'API
        this.generatorService.pushEmail(this.initialEmailId, exportedHtml).subscribe(
          (response) => {
            this.isExporting = false;
            if (response.status === 'success') {
              this.dialogService.open(this.dialogPushEmail, {
                context: { message: response.message }
              });
            } else {
              this.dialogService.open(this.dialogErrorPushEmail, {
                context: { message: "Échec de l'envoi de l'email." }
              });
            }
          },
          (error) => {
            this.isExporting = false;
            this.dialogService.open(this.dialogErrorPushEmail, {
              context: { message: "Erreur de communication avec le serveur." }
            });
          }
        );
      }

    } catch (error) {
      console.error('Erreur lors de l\'exportation :', error);
      this.isExporting = false;
    }
  }

  openExportTrackingDialog(): void {
    this.dialogRef = this.dialogService.open(this.dialogExportTracking, {
      context: {},
      hasBackdrop: true,
      closeOnBackdropClick: false,
      closeOnEsc: false,
      autoFocus: false
    });
  }

  private async sendToApi(endpoint: string, body: any): Promise<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    try {
      const backendEndpoint = environment.backendUrl + '/api/stripo/compress/';
      const response = await this.http.post(backendEndpoint, body, { headers }).toPromise();
      return response;
    } catch (error) {
      console.error('Erreur lors de l\'envoi à l\'API :', error);
      return null;
    }
  }

  public openExternalPreview(): void {
    this.showPopup = true;
    this.loadingPreview = true;
    this.save(false);
    const actionsApi = (window as any).StripoEditorApi?.actionsApi;

    if (!actionsApi?.getTemplateData || !actionsApi?.compileEmail) {
      console.error('[Stripo] actionsApi ou méthodes non disponibles.');
      this.loadingPreview = false;
      return;
    }

    actionsApi.getTemplateData((templateData: {
      html: string,
      css: string,
      width: number,
      height: number,
      utmParams?: any,
      syncModulesIds?: any[]
    }) => {

      const { html, css } = templateData;

      // Compilation
      actionsApi.compileEmail({
        callback: (error: string, compiledHtml: string, ampHtml: string, ampErrors: string[]) => {
          this.loadingPreview = false;
          if (error) {
            console.error('Erreur lors de la compilation de l\'email :', error);
            return;
          }

          const styledHtml = `${compiledHtml}`;
          const styledAmpHtml = ampHtml ? `${ampHtml}` : '';

          if (ampErrors?.length) {
            console.warn('Erreurs AMPHTML :', ampErrors);
          }

          if (this.emailPreviewPopupComponent) {

            const objet = window.StripoEditorApi.emailMetadataApi.getTitle()
            this.emailPreviewPopupComponent.openPreviewPopup(styledHtml, styledAmpHtml, this.userName, this.lastName, objet);
          } else {
            console.error('EmailPreviewPopupComponent non initialisé.');
          }
        },
        minimize: true, // conserve les sauts de ligne
      });

    });
  }

  public resize(imageUrl: string, newWidth: number, newHeight: number, imageElement: any, prompt: string): void {
    const ratio = newWidth / newHeight;
    this.imageSelectionService.resetImageUrls();

    this.generatorService.resizeImageRatio(imageUrl, ratio, prompt).subscribe(
      response => {
        // Mise à jour des URLs des images une fois la réponse reçue
        this.imageSelectionService.updateImageUrls([response['url'], response['url_1'], response['url_2']]);
      },
      error => {
        console.error('Erreur lors du redimensionnement de l\'image :', error);
      }
    );
  }

  public write(imageUrl: string, textUp: any, textDown: any, imageElement: any, single_text: any): void {
    this.imageSelectionService.resetImageOptions();
    const originalImageUrl = imageElement.attr('src');

    // Open dialog immediately with loading state
    const dialogRef = this.dialogService.open(WriteOnImageComponent, {
      context: {
        staticImageUrl: '',
      },
      hasBackdrop: true,
      closeOnBackdropClick: false,
      closeOnEsc: false,
      autoFocus: false
    });

    // Make the API call after dialog is opened
    (this.generatorService.writeOnImage(imageUrl, textUp, textDown, single_text) as Observable<any>).subscribe(
      (response: any) => {
        if (response.statut === 'ok') {
          // Update the service with the options
          this.imageSelectionService.updateImageOptions([
            response.text_image_center,
            response.text_image_left,
            response.text_image_right
          ]);

          // Only update staticImageUrl directly since imageOptions will come through the service
          dialogRef.componentRef.instance.staticImageUrl = response.resized_original_url;
        }
      },
      error => {
        console.error('Erreur lors du chargement des options d\'images', error);
        this.dialogRef = this.dialogService.open(this.dialogErrorWriteOnImage);
        dialogRef.close();
        imageElement.next('.esd-banner-generating').remove();
        imageElement.show();
      }
    );

    // Handle dialog close
    dialogRef.onClose.subscribe((result: { mergedImageUrl?: string } | null) => {
      if (result && result.mergedImageUrl) {
        imageElement.attr('src', result.mergedImageUrl);
      } else {
        if (result === undefined) {
          this.dialogRef = this.dialogService.open(this.dialogErrorWriteOnImage);
        } else {
          imageElement.attr('src', originalImageUrl);
        }
      }
      imageElement.next('.esd-banner-generating').remove();
      imageElement.show();
    });
  }

  private async processImages(html: string): Promise<string> {
    const regex = /https:\/\/storage\.googleapis\.com\/[^"']+?\.(jpeg|jpg|png|gif)/g;
    // Dédoublonné : une même image répétée dans l'email ne doit être envoyée
    // qu'une fois à Stripo (chaque envoi lui fait télécharger l'image).
    const googleImageUrls = Array.from(new Set(Array.from(html.matchAll(regex), m => m[0])));
    const urlMapping: Record<string, string> = {};

    await Promise.all(googleImageUrls.map(async (url) => {
      // Nouvelle méthode : on passe l’URL directement, pas de download/upload
      const stripoImageUrl = await this.uploadImageUrlToStripo(url, String(this.initialEmailId), this.userId, this.userName);
      urlMapping[url] = stripoImageUrl;
    }));

    return this.replaceImageUrls(html, urlMapping);
  }

  private async uploadImageUrlToStripo(
    imageUrl: string,
    emailId: string,
    userId: number,
    userName: string // Ajoute le username si tu veux mimer la requête manuelle
  ): Promise<string> {
    if (!this.authToken || this.isTokenExpired(this.authToken)) {
      try {
        const newToken = await new Promise<string>((resolve, reject) => {
          this.getNewAuthToken((token: string) => {
            if (token) resolve(token);
            else reject("Token refresh failed");
          });
        });
        this.authToken = newToken;
      } catch (e) {
        throw new Error('Auth token is not set and could not be refreshed');
      }
    }

    const response = await fetch('https://plugins.stripo.email/api/v1/documents/v3/documents/link', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Es-Plugin-Auth': `Bearer ${this.authToken}`,
        'Es-Plugin-Ui-Data': JSON.stringify({ emailId, UserId: userId, username: userName }),
        'Es-Plugin-Locale': 'fr', // ou la langue de ton app
        // 'Es-Plugin-Ui-Version': '2.27.0', // optionnel selon ton cas d’usage
      },
      body: JSON.stringify({
        key: `user_${userId}`,
        docType: 'LIBRARY',
        url: imageUrl
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Erreur lors de l'envoi de l'image à Stripo: ${errorText}`);
    }

    const data = await response.json();
    return data.url;  // URL Stripo CDN à injecter dans le template
  }

  private getImageExtension(mimeType: string): string {
    switch (mimeType) {
      case 'image/jpeg':
        return 'jpg';
      case 'image/jpg':
        return 'jpg';
      case 'image/png':
        return 'png';
      case 'image/gif':
        return 'gif';
      // ajoutez d'autres types d'image si nécessaire
      default:
        throw new Error(`Unsupported MIME type: ${mimeType}`);
    }
  }


  private replaceImageUrls(html: string, urlMapping: Record<string, string>): string {
    const modifiedHtml = html.replace(/https:\/\/storage\.googleapis\.com\/[^"']+?\.(jpeg|jpg|png|gif)/g, (match) => {
      return urlMapping[match] || match;
    });
    return modifiedHtml;
  }

  private async initImages(email: Email): Promise<void> {
    // Le jeton Stripo a été obtenu en parallèle dans ngOnInit.
    email.html = await this.processImages(email.html!);
  }

  public async initEditor(email: Email): Promise<void> {
    this.canTriggerAutosave = false;
    this.isLoading = true; // Démarrez le chargement
    try {
      this.loggingService.log(`Initializing editor for email ID: ${this.initialEmailId}`);
      await this.initImages(email);
      this.initStripo(email);
    } finally {
      this.isLoading = false; // Terminez le chargement une fois l'initialisation terminée
    }
  }


  private getAuthToken(): Observable<{ token: string }> {
    return this.http.post<{ token: string }>(
      environment.backendUrl + '/api/stripo/auth/',
      {}
    ).pipe(
      catchError(error => {
        throw error;
      })
    );
  }

  openCategorySelectionModal(categories: any[], selectedIds: number[], currentMetaId: number | null = null): Promise<any> {
    return new Promise((resolve) => {
      const ref = this.dialogService.open(CategorySelectionModalComponent, {
        closeOnBackdropClick: false,
        hasBackdrop: true,
        context: {
          categories: categories,
          selectedCategoryIds: selectedIds,
          initialMetaCategoryId: currentMetaId
        },
      });

      ref.onClose.subscribe((result) => {
        if (result !== undefined) {
          resolve(result);
        } else {
          // If cancelled, maybe reject or return null?
          // Existing logic returned selectedIds if undefined, but that implies no change or verify?
          // If user cancels, we probably shouldn't change anything.
          // But strict null check in consumer expects object.
          // Let's resolve undefined so consumer can check.
          resolve(undefined);
        }
      });
    });
  }

  openBackupSelectionModal(categories: any[], metaCategoryId: number, selectedIds: string[]): Promise<string[]> {
    return new Promise((resolve) => {
      const ref = this.dialogService.open(BackupSelectionModalComponent, {
        closeOnBackdropClick: false,
        hasBackdrop: true,
        context: {
          categories: categories,
          metaCategoryId: metaCategoryId,
          preSelectedProductIds: selectedIds
        },
      });

      ref.onClose.subscribe((ids) => {
        if (ids !== undefined) {
          resolve(ids);
        } else {
          resolve(selectedIds);
        }
      });
    });
  }

  private initForm(): void {
    this.form = this.formBuilder.group({
      title: this.formBuilder.control(''),
      hiddenPreHeader: this.formBuilder.control(''),
    });
  }

  private updateForm(): void {
    this.form.get('title')!.setValue(window.StripoEditorApi.emailMetadataApi.getTitle(), { emitEvent: false });
    this.form.get('hiddenPreHeader')!.setValue(window.StripoEditorApi.emailMetadataApi.getHiddenPreHeader(), { emitEvent: false });
  }

  private listenForm(): void {
    this.form
      .get('title')!
      .valueChanges.pipe(takeUntil(this.destroy$), debounceTime(1000))
      .subscribe((value) => {
        window.StripoEditorApi.emailMetadataApi.setTitle(value);
      });

    this.form
      .get('hiddenPreHeader')!
      .valueChanges.pipe(takeUntil(this.destroy$), debounceTime(1000))
      .subscribe((value) => {
        window.StripoEditorApi.emailMetadataApi.setHiddenPreHeader(value);
      });
  }

  /**
   * Lit le template courant depuis Stripo.
   *
   * Le callback de `getTemplateData` peut ne jamais être rappelé (iframe dans un
   * état bancal, éditeur démonté entre-temps). Cette promesse est donc bornée
   * dans le temps : sans cela, `save()` restait en attente indéfiniment et ne
   * relâchait jamais ses verrous, ce qui coupait l'autosave en silence et
   * laissait le bouton « Enregistrer » désactivé jusqu'au rechargement de la page.
   */
  private getTemplateFromEditor(): Promise<{ html: string, css: string }> {
    return new Promise((resolve, reject) => {
      const actionsApi = (window as any).StripoEditorApi?.actionsApi;

      if (!actionsApi?.getTemplateData) {
        reject(new Error('StripoEditorApi.actionsApi.getTemplateData non disponible'));
        return;
      }

      let settled = false;
      const timer = setTimeout(() => {
        if (settled) return;
        settled = true;
        reject(new Error(`getTemplateData : aucune réponse de Stripo après ${TEMPLATE_READ_TIMEOUT_MS} ms`));
      }, TEMPLATE_READ_TIMEOUT_MS);

      actionsApi.getTemplateData((data: {
        html: string,
        css: string,
        width?: number,
        height?: number,
        utmParams?: any,
        syncModulesIds?: string[]
      }) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);

        if (!data?.html) {
          reject(new Error('HTML vide ou null'));
        } else {
          resolve({ html: data.html, css: data.css });
        }
      });
    });
  }

  private initStripo(email: Email): Promise<void> {
    return new Promise(() => {
      this.initializeStripo(email);
    });
  }

  public currentCategories: any[] = [];

  private async initializeStripo(email: Email): Promise<void> {
    let categoryNames = "";
    this.currentCategories = [];

    // Tenter de charger les catégories.
    // `firstValueFrom` + `timeout` : les catégories sont un confort d'édition,
    // elles ne doivent JAMAIS empêcher Stripo de s'initialiser. Avec
    // `lastValueFrom`, un observable qui n'émettait ni ne complétait laissait cet
    // `await` en attente pour toujours et l'éditeur ne s'affichait jamais.
    try {
      const categories$ = email.meta_category_id
        // Cas 1 : on a un ID spécifique
        ? this.categoryService.getCategories([email.meta_category_id])
        // Cas 2 : on n'a pas d'ID, on demande au service ses catégories par défaut (basé sur le currentMeta par défaut)
        // Le service gère le chargement si nécessaire
        : this.categoryService.getCategories();

      this.currentCategories = await firstValueFrom(
        categories$.pipe(timeout(CATEGORIES_LOAD_TIMEOUT_MS)),
      );

      if (email.category_ids && email.category_ids.length > 0) {
        categoryNames = this.currentCategories
          .filter(c => email.category_ids!.some(id => Number(id) === c.id))
          .map(c => c.label)
          .join(', ');
      }
      console.log('DEBUG: email.category_ids:', email.category_ids);
      console.log('DEBUG: this.currentCategories:', this.currentCategories);
      console.log('DEBUG: computed categoryNames:', categoryNames);
    } catch (e) {
      console.warn('Could not fetch categories', e);
    }

    return new Promise((resolve, reject) => {
      this.zone.runOutsideAngular(() => {
        // Nettoyage préventif
        try {
          (window as any).UIEditor?.removeEditor();
        } catch (e) { }

        // Une entrée valide du presse-papier natif Stripo fait geler l'éditeur au
        // démarrage (voir purgeStripoPortableClipboard). À faire AVANT initEditor.
        purgeStripoPortableClipboard();

        const container = document.querySelector('#stripoEditorContainer');
        const UIEditor = (window as any).UIEditor;

        if (!UIEditor?.initEditor) {
          console.error('UIEditor.initEditor indisponible.');
          reject('Editor not available');
          return;
        }

        // Capture dependencies for injection into custom controls
        const generatorServiceInstance = this.generatorService;
        const dialogServiceInstance = this.dialogService;
        const imageSelectionServiceInstance = this.imageSelectionService;
        const dialogErrorAnimateInstance = this.dialogErrorAnimate;
        const toastServiceInstance = this.toastService;
        const envPrefix = window.location.hostname === 'app.deebr.co' ? 'prod-' : 'preprod-';
        const emailId = envPrefix + this.initialEmailId;
        const userId = this.userId;
        const userName = this.userName;
        const authToken = this.authToken;
        const componentInstance = this;

        // Custom Dynamic Control with specific closure context

        console.log('[Deebr] FULL EMAIL OBJECT:', email);

        // Pass the global dynamic context to the static property
        // We use campaign_id as the indicator of a dynamic email
        DynamicControl.isDynamicEmail = !!email.campaign_id;
        console.log('[Deebr] Setting DynamicControl.isDynamicEmail =', DynamicControl.isDynamicEmail);

        // Template d'origine de l'email : « Copier la bande » le tamponne sur les blocs produit
        // (data-deebr-template-id) pour que la personnalisation retrouve leur slot non rempli
        // même une fois collés dans un email construit sur un autre template.
        CopyPasteControl.currentTemplateId = email.template_id ?? null;

        // Parse email defaults once and expose them on DynamicControl statics so
        // applyDynamic() can auto-seed category attributes when the user enables
        // dynamic on a container (before the nested settings panel mounts).
        let emailCatIds: any = email.category_ids || [];
        if (typeof emailCatIds === 'string') {
          try { emailCatIds = JSON.parse(emailCatIds); } catch { emailCatIds = []; }
        }
        const defaultCategoryIds = Array.isArray(emailCatIds) ? emailCatIds.map(Number) : [];
        const defaultMetaCategoryId = email.meta_category_id ? Number(email.meta_category_id) : undefined;
        DynamicControl.defaultCategoryIds = defaultCategoryIds;
        DynamicControl.defaultMetaCategoryId = defaultMetaCategoryId;

        class CustomDynamicSettingsControl extends DynamicSettingsControl {
          constructor() {
            super();
            this.currentCategoryNames = categoryNames;
            this.currentCategoryIds = defaultCategoryIds;
            this.currentMetaCategoryId = defaultMetaCategoryId;
            this.hasSizeData = componentInstance.hasSizeData;
            this.hasSizeStock = componentInstance.hasSizeStock;
            // Capture 'currentCategories' from the parent scope
            this.openCategoriesModal = (ids?: number[], metaId?: number) => {
              // Call the component method to open the modal
              return componentInstance.openCategorySelectionModal(componentInstance.currentCategories, ids || [], metaId);
            };
            this.resolveCategoryNames = (ids: number[]) => {
              if (!ids || ids.length === 0) return '';
              return componentInstance.currentCategories
                .filter(c => ids.includes(c.id))
                .map(c => c.label)
                .join(', ');
            };
          }
        }

        class CustomBackupControl extends BackupControl {
          constructor() {
            super();
            this.openBackupSelectionModal = (ids?: string[]) => {
              return componentInstance.openBackupSelectionModal(componentInstance.currentCategories, email.meta_category_id || 0, ids || []);
            }
          }
        }

        // Helper to ensure fresh token usage
        const uploadDelegate = (url: string) => {
          return componentInstance.uploadImageUrlToStripo(url, String(componentInstance.initialEmailId), componentInstance.userId, componentInstance.userName);
        };

        const isDynamicEmail = !!email.campaign_id;

        // 1. VISUAL STYLES (Always applied, so user sees what is dynamic)
        const visualStyles = `
            /* VISUAL: Default for blocks/structures (Structures, Containers, Blocks) */
            [deebr-data-dynamic="true"] {
              --active-box-shadow: #74cdcde6 !important;
              position: relative; /* Needed for ::after icon */
            }

            /* Stripes: use the same --active-box-shadow, just ensure relative positioning */
            .esd-stripe[deebr-data-dynamic="true"] {
              position: relative !important;
            }

            /* No outline on children if the stripe itself is dynamic (cleaner look) */
            .esd-stripe[deebr-data-dynamic="true"] .esd-structure {
              outline: none !important;
            }
            
            /* DYNAMIC BLOCKS STYLING */
            [deebr-data-dynamic="true"],
            .esd-structure:has([deebr-data-dynamic="true"]),
            .esd-container-frame:has([deebr-data-dynamic="true"]),
            .esd-stripe:has([deebr-data-dynamic="true"]) {
               position: relative !important;
            }

            /* ICON positioning (Still using ::after for visual) */
            [deebr-data-dynamic="true"]::after {
              content: "🪄";
              position: absolute;
              top: 5px;
              left: 5px;
              width: auto;
              height: auto;
              background: #74cdcd;
              color: transparent !important;
              text-shadow: 0 0 0 white !important;
              padding: 2px 10px;
              font-size: 14px;
              border-radius: 10%;
              font-weight: bold;
              z-index: 2147483647 !important;
              pointer-events: none; 
            }

            /* Adjust icon for Stripes - auto-adapts: 105px in desktop, 5px in mobile */
            .esd-stripe[deebr-data-dynamic="true"]::after {
              top: 5px !important;
              left: min(105px, max(5px, calc(100% - 600px))) !important;
              z-index: 2147483647 !important;
            }
        `;

        // 2. LOCKING STYLES (Only for Dynamic Emails)
        const lockingStyles = `
            /* FUNCTIONAL LOCK - Block children but allow parent selection */
            [deebr-data-dynamic="true"] *,
            .esd-structure:has([deebr-data-dynamic="true"]) *,
            .esd-container-frame:has([deebr-data-dynamic="true"]) *,
            .esd-stripe:has([deebr-data-dynamic="true"]) * {
               pointer-events: none !important;
               user-select: none !important;
            }
        `;

        const finalPreviewStyles = visualStyles + (isDynamicEmail ? lockingStyles : '');

        const builder = new ExtensionBuilder()
          .addControl(class extends CustomToolbarButtonControl {
            constructor() {
              super();
              this.generatorService = generatorServiceInstance;
              this.imageSelectionService = imageSelectionServiceInstance;
              this.dialogService = dialogServiceInstance;
              this.dialogErrorAnimate = dialogErrorAnimateInstance;
              this.toastService = toastServiceInstance;
              this.emailId = emailId;
              this.userId = userId;
              this.userName = userName;
              this.enterpriseId = componentInstance.enterpriseId;
              this.uploadToStripoDelegate = uploadDelegate;
            }
          })
          .addControl(class extends WriteOnImageControl {
            constructor() {
              super();
              this.generatorService = generatorServiceInstance;
              this.dialogService = dialogServiceInstance;
              this.imageSelectionService = imageSelectionServiceInstance;
              this.dialogErrorAnimate = dialogErrorAnimateInstance;
              this.emailId = emailId;
              this.userId = userId;
              this.userName = userName;
              this.uploadToStripoDelegate = uploadDelegate;
            }
          })
          .addStyles(`
            .e2e-category,
            .e2e-folder {
              display: none !important;
            }

            .service-element.container:has(> ue-multiple-select)::after {
              content: "Appuyez sur Entrée après chaque balise pour qu'elle soit prise en compte.";
              display: block;
              font-size: 12px;
              color: #ff6384;
              font-style: italic;
              margin-top: 6px;
            }
          `)
          .addControl(TextTransformControl)
          .addControl(class extends DynamicControl {
            constructor() {
              super();
              this.toastService = toastServiceInstance;
            }
          })
          .addControl(CustomDynamicSettingsControl)
          .addControl(class extends CopyPasteControl {
            constructor() {
              super();
              this.toastService = toastServiceInstance;
            }
          });

        // Le contrôle Backup était déclaré dans le panneau de réglages alors que
        // sa classe n'était plus fournie (`.addControl` commenté). Stripo ne
        // trouvait donc pas `backup-control` à l'ouverture des réglages d'un
        // conteneur. Les deux sont maintenant pilotés par ce seul drapeau : le
        // passer à `true` réactive la fonctionnalité complète, des deux côtés.
        if (ENABLE_BACKUP_CONTROL) {
          builder.addControl(CustomBackupControl);
        }

        const extension = builder
          .withSettingsPanelRegistry(createSettingsRegistryClass(this.dynamicHtml, ENABLE_BACKUP_CONTROL))

          .withPreviewStyles(finalPreviewStyles)

          .build();

        // Initialize the editor
        UIEditor.initEditor(container, {
          metadata: {
            emailId: envPrefix + this.initialEmailId,
            UserId: envPrefix + this.userId.toString(),
            username: this.userName,
          },
          ignoreClickOutsideSelectors: ['.cdk-overlay-container'],
          // ignoreClickSelectors REMOVED to allow our custom overlay to catch clicks
          html: email.html!,
          css: email.css!,
          locale: 'fr',
          forceRecreate: true,
          extensions: [extension], // Pass the built extension here

          onTokenRefreshRequest: this.getAuthTokenCallback(),

          // UI Configuration
          undoButtonSelector: '#undoButton',
          redoButtonSelector: '#redoButton',
          codeEditorButtonSelector: '#codeEditor',
          versionHistoryButtonSelector: "#changeHistoryLink",
          conditionsEnabled: true,
          customConditionsEnabled: true,
          customBlocksEnabled: true,

          // View handling
          onVersionHistoryVisibilityChanged: (isVisible: boolean) => {
            this.zone.run(() => {
              this.showToolbox = !isVisible;
              if (isVisible && window.StripoEditorApi && window.StripoEditorApi.versionHistoryApi?.getCurrentPreviewMode) {
                // Suppose que cette API existe :
                const mode = window.StripoEditorApi.versionHistoryApi.getCurrentPreviewMode(); // 'desktop' ou 'mobile'
                this.selectedView = mode;
              }
            });
          },
          desktopViewButtonSelector: '#desktop',
          mobileViewButtonSelector: '#mobile',
          viewOptions: {
            showHiddenElements: this.areHiddenElementsHidden,
            // templateThemeMode: { data: 'DARK' } // Removed hardcoded test value
          },

          // Event handlers
          onEvent: (type: string, params: any) => {
            console.log('Event:', type, params);
            this.zone.run(() => {
              if (type === 'view_options_restored') {
                window.StripoEditorApi.viewOptionsApi.setViewOptions({ showHiddenElements: true });
                this.areHiddenElementsHidden = true;
                this.isToggleVisible = false;
                this.cdr.detectChanges();
                setTimeout(() => {
                  this.isToggleVisible = true;
                  this.cdr.detectChanges();
                }, 10);
              }
            });
          },

          onSaveStarted: () => { this.isSaving = true; },
          onSaveCompleted: () => { this.isSaving = false; },

          onDataChanged: () => {
            this.updateForm();
            if (this.canTriggerAutosave) {
              this.autosaveSubject.next();
            }
            this.checkHasDynamicBlock();
          },

          onTemplateLoaded: () => {
            this.updateForm();
            this.listenForm();
            window.StripoEditorApi.viewOptionsApi.setViewOptions({
              showHiddenElements: this.areHiddenElementsHidden,
              // templateThemeMode: { data: 'DARK' }
            });

            // Les banners remplis côté backend n'ont jamais été "cuits" par l'éditeur :
            // sans modification utilisateur, Stripo ne régénère pas l'image aplatie
            // (POST documents/base64) et le texte n'apparaît ni en preview ni à l'export.



            // // Hides the settings panel
            setTimeout(() => {
              this.canTriggerAutosave = true;
              this.checkHasDynamicBlock();
              this.rebakeBanners();
            }, 2000);
            resolve();
          },

          editorFonts: {
            showDefaultStandardFonts: true,
            showDefaultNotStandardFonts: true,
            customFonts: [
              {
                name: "Montserrat",
                fontFamily: "'Montserrat', 'helvetica neue', helvetica, arial, sans-serif",
                url: "https://fonts.googleapis.com/css?family=Montserrat&display=swap"
              },
              {
                name: "Jost",
                fontFamily: "'Jost', 'serif'",
                url: "https://fonts.googleapis.com/css2?family=Jost&display=swap"
              },
            ],
          },

          onError: (error: any) => {
            console.error('[Debug] onError editor:', error);
            reject(error);
          },

          panelPosition: 'BLOCKS_SETTINGS',
          shouldBeSavedToLibrary: () => true,
        });
      });
    });
  }

  // Force la régénération de l'image aplatie de chaque bloc banner : on repasse
  // par le circuit officiel de modification (le même que bannerChildColorForm),
  // ce qui déclenche le rendu canvas + upload vers le CDN Stripo.
  private rebakeBanners(): void {
    try {
      const copilotApi = (window.StripoEditorApi as any)?.editorCopilotApi;
      if (!copilotApi) {
        console.warn('[rebakeBanners] editorCopilotApi indisponible');
        return;
      }
      const root = copilotApi.getDocumentRootHtmlNode();
      const textNodes: any[] = root.querySelectorAll('banner text');
      if (!textNodes.length) return;

      const modifier = copilotApi.getTemplateModifier();
      textNodes.forEach((node) => {
        // Nudge d'opacité ±0.001 : diff numérique réel (les couleurs peuvent être
        // normalisées par Stripo, pas les floats), invisible à l'écran. Le flag
        // hasChangesToGenerate du banner est alors posé, et Stripo régénérera
        // l'image aplatie (POST documents/base64) au prochain save/preview/export.
        const millis = Math.round(parseFloat(node.getAttribute('opacity') || '1') * 1000);
        // Ping-pong sur le 3e chiffre (pair -1 / impair +1) : pas de dérive cumulative
        const nudged = Math.min(1000, Math.max(1, millis % 2 === 0 ? millis - 1 : millis + 1));
        modifier.modifyHtml(node).setAttribute('opacity', (nudged / 1000).toFixed(3));
      });
      modifier.apply(new ModificationDescription('Rebake banners'));
      console.log(`[rebakeBanners] ${textNodes.length} texte(s) de banner marqué(s) à régénérer`);
    } catch (e) {
      console.error('[rebakeBanners] échec', e);
    }
  }

  private getAuthTokenCallback(): (callback: any) => void {
    return (callback: any) => {
      // Première demande (à l'initialisation) : on remet le jeton obtenu il y a
      // quelques secondes pendant le chargement, ce qui évite un aller-retour.
      // Consommé une seule fois et seulement s'il est très récent.
      const prefetched = this.prefetchedStripoToken;
      this.prefetchedStripoToken = null;
      if (prefetched
        && Date.now() - prefetched.fetchedAt < PREFETCHED_TOKEN_MAX_AGE_MS
        && !this.isTokenExpired(prefetched.token)) {
        callback(prefetched.token);
        return;
      }

      // Always get a new token when Stripo explicitly asks for a refresh.
      // Caching here is dangerous because Stripo might simply be proactive
      // or the local clock might be slightly off.
      this.getNewAuthToken(callback);
    };
  }

  private isTokenExpired(token: string): boolean {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload));
    const exp = decoded.exp * 1000; // Convertir UNIX timestamp en milliseconds
    return Date.now() > exp;
  }

  private getNewAuthToken(callback: Function): void {
    this.getAuthToken().subscribe({
      next: (res: { token: string }) => {
        this.authToken = res.token;
        callback(res.token);
      },
      error: () => {
        console.log('Failed to fetch new token');
        callback(null);
      },
    });
  }

  private showEmailOverlay() {
    const wrapper = document.getElementById('stripoEditorWrapper');
    if (!wrapper) return;
    if (wrapper.querySelector('#deebr-email-overlay')) return;

    const overlay = document.createElement('div');
    overlay.className = 'deebr-email-overlay';
    overlay.id = 'deebr-email-overlay';
    overlay.innerHTML = `<div class="spinner"></div>`;
    wrapper.appendChild(overlay);
  }

  private hideEmailOverlay() {
    const overlay = document.getElementById('deebr-email-overlay');
    overlay?.remove();
  }

  onimageToGifButtonClick(jElement: any): void {
    const imageElement = jElement.find('img');
    const imageUrl = imageElement.attr('src').split('?')[0];
    const width_block = imageElement.attr('width');

    const supportedFormats = ['jpeg', 'jpg', 'png', 'webp'];
    const imageExtension = imageUrl.split('.').pop().toLowerCase();

    if (!supportedFormats.includes(imageExtension)) {
      this.errorMessage = "Uniquement les format jpeg, png et webp sont supportés pour l'animation.";
      this.dialogRef = this.dialogService.open(this.dialogErrorAnimate);
      return;
    }

    // Affiche l’overlay dès l’ouverture du dialog
    this.showEmailOverlay();

    const dialogRef = this.dialogService.open(ImageToGifDialogComponent, {
      context: { imageUrl, width_block },
      hasBackdrop: true,
      closeOnBackdropClick: false,
      closeOnEsc: false,
      autoFocus: false,
      dialogClass: 'custom-dialog'
    });

    dialogRef.componentRef.instance.imageUrl = imageUrl;

    dialogRef.onClose.subscribe(async (result: string) => {
      try {
        if (!result) {
          // annulé → retire l’overlay
          this.hideEmailOverlay();
          return;
        }

        // 1) Précharge le GIF (attend que le browser puisse l’afficher)
        await new Promise<void>((resolve, reject) => {
          const pre = new Image();
          pre.onload = () => resolve();
          pre.onerror = () => reject(new Error('Préchargement GIF échoué'));
          // facultatif: éviter le cache dur
          const url = result.includes('?') ? `${result}&_=${Date.now()}` : `${result}?_=${Date.now()}`;
          pre.src = url;
        });

        // 2) Remplace la source dans l’iframe (via jQuery clone -> visible immédiatement)
        imageElement.attr('src', result);

      } catch (e) {
        console.error(e);
        this.errorMessage = "Erreur lors du chargement du GIF.";
        this.dialogService.open(this.dialogErrorAnimate);
      } finally {
        // 3) Retire l’overlay quoi qu’il arrive
        this.hideEmailOverlay();
      }
    });
  }

  closeDialog() {
    this.dialogRef?.close();
  }

  public async exportSocialMedia(): Promise<void> {
    this.loading = true;
    await this.save(true); // Wait for the template to be saved and loaded
    setTimeout(() => {
      this.generatorService.exportSocial(this.previewImgUrl!, this.previewHtmlUrl!)
        .subscribe(
          response => {
            const blob = new Blob([response], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'social_media.zip';
            document.body.appendChild(a); // Required for Firefox
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
            this.loading = false;
          },
          error => {
            this.dialogRef = this.dialogService.open(this.dialogErrorExport);
            this.loading = false;
          }
        );
    }, 2000);
  }
}

declare var window: any;
